import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.NgxAuthModule),
  },
  {
    path: '',
    loadChildren: () => import('../app/pages/pages.module').then((m) => m.PagesModule),
  },
  { path: '', redirectTo: 'smart-flow/dashboard', pathMatch: 'full' },
  { path: '**', redirectTo: 'auth/login' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
